import { store } from "../../app/store"
import { setProfileId } from "../../app/slices/selectedProfileSlice"
import {
  FunctionCard,
  Paragraph,
  Button,
  Tooltip,
  Icon,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { OAuth2ClientData } from "@smartx/mikro-vt-client-api"
import { ICON } from "@george-labs.com/george-assets/icons"

interface IUserSelectionItemProps {
  userData: OAuth2ClientData
}

const UserSelectionItem = (props: IUserSelectionItemProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const userSelected = (userId: string) => {
    store.dispatch(setProfileId(userId))
    navigate("/dashboard")
  }

  return (
    <FunctionCard
      horizontal
      buttons={[
        <Button
          variant={Button.VARIANT.SECONDARY}
          disabled={!props.userData.mikroCompany}
          key={props.userData.id}
          onClick={() => userSelected(props.userData.id)}
        >
          {t("common.button.select")}
        </Button>,
      ]}
      icon={FunctionCard.ICON.BUSINESS}
    >
      <Paragraph className="font-weight-bold">
        {props.userData.name}
        {!props.userData.mikroCompany && (
          <Tooltip
            content={t("user-selection.tooltip.notMikroCompany")}
            enabled={false}
            usePortal={true}
            className="ml-3"
            showOnHover={true}
            tooltipClassName="ml-2"
          >
            <Icon
              className="ml-3"
              assetIcon={ICON.INFO}
              useDetailed={false}
              size={Icon.SIZE.SIZE_16}
            />
          </Tooltip>
        )}
      </Paragraph>
      <Paragraph>
        {t("user-selection.taxNumber")}: {props.userData.taxNumber}
      </Paragraph>
    </FunctionCard>
  )
}

export default UserSelectionItem
